import React from 'react'

import { TDatasetMarker } from 'components_new/molecules/charts/chartjs-plugins'
import { TKeyMetric } from 'types/GlobalKeyMetric'
import { CreateCommentBody } from 'types/GlobalComment'

import { useCommentActions } from 'redux/actions/Comments'
import { useCommentThreads } from 'redux/hooks/Comments'
import { useTranslation } from 'language/translator'

import Button from 'components_new/atoms/Button'

import CommentThreads from 'components_new/molecules/CommentThreads'
import SidebarDialog from 'components_new/molecules/SidebarDialog'

import { COMMENT_CHAR } from 'components_new/organisms/MetricView/utils'
interface Props {
  keyMetric: TKeyMetric
  label?: string
  markers: TDatasetMarker[]
  onClose: () => void
  open: boolean
}

const MetricMarkersDialog = (props: Props) => {
  const { keyMetric, label, markers, onClose, open } = props

  const { t } = useTranslation()
  const { tryCreateComment } = useCommentActions()

  const commentThreads = useCommentThreads(keyMetric.id)

  const commentThreadIds = markers
    .filter((marker) => marker.char === COMMENT_CHAR)
    .map((marker) => marker.id)

  const displayedCommentThreads = commentThreads.filter((commentThread) =>
    commentThreadIds.includes(commentThread.id)
  )

  if (!keyMetric) return null

  return (
    <SidebarDialog
      actions={
        <Button onClick={onClose} variant="text">
          {t('global', 'close')}
        </Button>
      }
      PaperProps={{ sx: { height: '60vh' } }}
      maxWidth="xs"
      onClose={onClose}
      open={open}
      title={label}
    >
      <CommentThreads
        CommentThreadProps={{
          border: false,
          disabledPadding: true,
          displayHeader: false
        }}
        commentThreads={displayedCommentThreads}
        keyMetricId={keyMetric.id}
        onCreateComment={(body: CreateCommentBody) => {
          tryCreateComment(body)
        }}
      />
    </SidebarDialog>
  )
}

export default MetricMarkersDialog
